<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Admin Info</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">Admin</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="main-content-label mb-1">Admin Info</h6>
              <div class="d-flex" v-if="isEdit">
                <div class="justify-content-center">
                  <buttob :to="'/admin/add'" @click="openModal = !openModal" type="button" class="btn btn-primary my-2 btn-icon-text">
                    {{openModal ? 'Update Info': 'Update Password'}}
                  </buttob>
                </div>
              </div>
            </div>
            <div v-if="openModal">
              <ValidationObserver ref="updatePasswordForm" id="updatePasswordForm" tag="form" class="d-flex flex-column" @submit.prevent="passwordConfirmation()">
                <ValidationProvider v-slot="{ classes }" rules="required|min:6" tag="div" class="form-group">
                  <label for="current_password" class="form-label">Current Password:</label>
                  <input id="current_password" class="form-control" name="current_password" v-model="passwordData.current_password" :class="checkValidation(classes)" placeholder="current_password" type="password">
                </ValidationProvider>
                <ValidationProvider v-slot="{ classes }" vid="confirmation" rules="required|min:6" tag="div" class="form-group">
                  <label for="password1" class="form-label">Password:</label>
                  <input id="password1" class="form-control" name="password" v-model="passwordData.password" :class="checkValidation(classes)" placeholder="password" type="password">
                </ValidationProvider>
                <ValidationProvider v-slot="{ classes }" rules="required|min:6|confirmed:confirmation" tag="div" class="form-group">
                  <label for="confirm_password1" class="form-label">Confirm Password:</label>
                  <input id="confirm_password1" class="form-control" name="password_confirmation" v-model="passwordData.password_confirmation" :class="checkValidation(classes)" placeholder="confirm password" type="password">
                </ValidationProvider>
                <button class="btn ripple btn-main-primary" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
            <div v-else>
              <ValidationObserver ref="newsAddForm" id="addNewsForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <div>
                  <div>
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label for="name" class="form-label">Name:</label>
                      <input id="name" class="form-control" name="name" v-model="formData.name" :class="checkValidation(classes)" placeholder="name" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" rules="required|email" tag="div" class="form-group">
                      <label for="email" class="form-label">Email:</label>
                      <input id="email" class="form-control" name="email" v-model="formData.email" :class="checkValidation(classes)" placeholder="email" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-if="!isEdit" v-slot="{ classes }" vid="confirmation" rules="required|min:6" tag="div" class="form-group">
                      <label for="password" class="form-label">Password:</label>
                      <input id="password" class="form-control" name="password" v-model="formData.password" :class="checkValidation(classes)" placeholder="password" type="password">
                    </ValidationProvider>
                    <ValidationProvider v-if="!isEdit" v-slot="{ classes }" rules="required|min:6|confirmed:confirmation" tag="div" class="form-group">
                      <label for="confirm_password" class="form-label">Confirm Password:</label>
                      <input id="confirm_password" class="form-control" name="password_confirmation" v-model="formData.password_confirmation" :class="checkValidation(classes)" placeholder="confirm password" type="password">
                    </ValidationProvider>
<!--                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">-->
<!--                      <label for="role" class="form-label">Roles:</label>-->
<!--                      <select id="role" class="form-control" name="password_confirmation" v-model="formData.role_id" :class="checkValidation(classes)">-->
<!--                        <option v-for="(item, i) in roles" :value="item.id" :key="i">{{item.name}}</option>-->
<!--                      </select>-->
<!--                    </ValidationProvider>-->
                    <ValidationProvider rules="required" tag="div" class="form-group">
                      <multiselect v-model="formData.admin_roles" placeholder="Select Page" :close-on-select="true" :multiple="true" track-by="id" @close="selectRoles(formData.admin_roles)" :custom-label="customLabel" :options="roles">
                        <template slot="singleLabel" slot-scope="props">
                          {{props.option.name}}
                        </template>
                        <template slot="option" slot-scope="props">
                          <span class="option__name">{{props.option.name}}</span>
                        </template>
                      </multiselect>
                    </ValidationProvider>
                  </div>
                </div>
                <button class="btn ripple btn-main-primary" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddNews',
  data () {
    return {
      buttonDisable: false,
      openModal: false,
      formData: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        errClass: false
      },
      passwordData: {
        password: '',
        password_confirmation: '',
        current_password: ''
      },
      uploadedVideoFile: {},
      videoType: 'video_iframe',
      serviceInfoId: null,
      categories: null,
      letterCount: '',
      roles: [],
      wordCount: ''
    }
  },
  created () {
    this.gatAllRoles().then(res => {
      this.roles = res
    })
    if (this.$route.params.id === 'add') {
      this.isEdit = false
    } else {
      this.isEdit = true
      this.getAdminInfo(this.$route.params.id).then(res => {
        this.formData = res
        this.passwordData.id = res.id
      })
    }
  },
  methods: {
    ...mapActions({
      gatAllRoles: 'admin/gatAllRoles',
      getAdminInfo: 'admin/getAdminInfo',
      createAdminInfo: 'admin/createAdminInfo',
      updateAdminInfo: 'admin/updateAdminInfo',
      updatePassword: 'auth/updatePassword'
    }),
    checkValidation (data) {
      return data
    },
    customLabel ({ name, desc }) {
      return `${name}`
    },
    selectRoles (value) {
      console.log(value)
      // this.formData = value.id
    },
    passwordConfirmation () {
      this.$refs.updatePasswordForm.validate().then(success => {
        if (success) {
          this.updatePassword(this.passwordData).then(() => {
            this.$toasted.success('password changed successfully:').goAway(1500)
            this.$router.push('/admins')
            this.$refs.updatePasswordForm.reset()
          }).catch(err => {
            if (err.response.status === 422) {
              const data = err.response.data.errors
              const keys = Object.keys(data)
              const msg = data[keys[0]][0]
              this.$toasted.error(msg).goAway(1500)
            } else {
              this.$toasted.error('You have entered wrong password!').goAway(1500)
            }
          })
        }
      })
    },
    formSubmit () {
      this.$refs.newsAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          this.formData.roles = this.formData.admin_roles.map((item) => {
            return item.id
          })
          if (this.$route.params.id === 'add') {
            this.createAdminInfo({ data: this.formData }).then(res => {
              this.$toasted.success(this.$t('messages.success.newsUpdated')).goAway(1500)
              this.$router.push('/admins')
            }).catch(err => {
              if (err.response.status === 422) {
                const data = err.response.data.errors
                if (data) {
                  const keys = Object.keys(data)
                  const msg = data[keys[0]][0]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.data.message).goAway(1500)
                }
              } else {
                this.$toasted.error('You have entered wrong password!').goAway(1500)
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.updateAdminInfo({ data: this.formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.newsUpdated')).goAway(1500)
              this.$router.push('/admins')
            }).catch(err => {
              if (err.response.status === 422) {
                const data = err.response.data.errors
                if (data) {
                  const keys = Object.keys(data)
                  const msg = data[keys[0]][0]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.data.message).goAway(1500)
                }
              } else {
                this.$toasted.error('You have entered wrong password!').goAway(1500)
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    },
    uploadCoverFile (file) {
      const uploadFile = file[0]
      this.uploadedVideoFile = uploadFile
    }
  }
}
</script>
